import { getRubrosNombres } from "../enums/Rubro.tsx";
import { getNombreSegmento } from "../enums/Segmento.tsx";
import {getNombreTipoSocio } from "../enums/TipoSocio.tsx";
import { Socio } from "../types/Socio.tsx";

export default function completSocio(Socio: Socio) {
    const completSocio = {
        ...Socio,
        socio_rubro: getRubrosNombres(Socio.socio_rubro, Socio.socio_rubros) || "No definido", 
        socio_segmento: getNombreSegmento(parseInt(Socio.socio_segmento)) || "No definido",
        socio_tipoSocio: getNombreTipoSocio(Socio.socio_tipoSocio) || "No definido",
        socio_nombre: Socio.socio_nombre || "No definido",
        socio_dni: Socio.socio_dni || "No definido",
        socio_cuit: Socio.socio_cuit || "No definido",
        socio_domicilio: Socio.socio_domicilio || "No definido",
        socio_localidad: Socio.socio_localidad_nombre || Socio.socio_localidad,
        socio_celular: Socio.socio_celular || "No definido",
        socio_telefono: Socio.socio_telefono || "No definido",
        socio_otroTelefono: Socio.socio_otroTelefono || "No definido",
    };
    return completSocio;
}